<div class="sam-form-flex-row sam-full-width">
   <fa-icon [icon]="icon" [fixedWidth]="true"></fa-icon>
   <div style="width: 50%">header</div>
   <div style="float: right">value</div>
</div>
